export default class Property {
  constructor(record = {}) {
    this.PrcsParmtrName = record.PrcsParmtrName || undefined;
    this.PrcsParmtrValue = record.PrcsParmtrValue || undefined;
    this.PrcsParmtrX = record.PrcsParmtrX || undefined;
    this.Vrs = record.Vrs || undefined;
    this.VisualId = record.VisualId || undefined;
    this.VisualName = record.VisualName || undefined;
    this.VisualCmpnt = record.VisualCmpnt || undefined;
    this.VisualState = record.VisualState || undefined;
    this.VisualType = record.VisualType || undefined;
    this.VisualProperties = record.VisualProperties || record.VisualPropertys || undefined;

    this.lastUpdatedOn = record.lastUpdatedOn || undefined;
    this.lastUpdatedBy = record.lastUpdatedBy || undefined;
  }
}
